import React from 'react';

const StagingBanner: React.FC = () => {
  const env = process.env.REACT_APP_ENV;

  if (env !== 'staging') {
    return null;
  }

  return (
    <div
      style={{
        background: '#f97316',
        color: 'white',
        textAlign: 'center',
        padding: '6px 0',
        fontWeight: 700,
        fontSize: '13px',
        letterSpacing: '0.1em',
        textTransform: 'uppercase',
        position: 'sticky',
        top: 0,
        zIndex: 9999,
      }}
    >
      Staging Environment
    </div>
  );
};

export default StagingBanner;
